import { render, staticRenderFns } from "./ErrorDialog.vue?vue&type=template&id=4ea8966e"
import script from "./error-dialog.ts?vue&type=script&lang=ts&external"
export * from "./error-dialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports